// https://stackoverflow.com/questions/44195322/a-plain-javascript-way-to-decode-html-entities-works-on-both-browsers-and-node
// eslint-disable-next-line import/prefer-default-export

const translate = {
  "nbsp": " ",
  "amp": "&",
  "quot": "\"",
  "lt": "<",
  "gt": ">"
};
export const decodeEntities = encodedString => {
  const translateRegExp = /&(nbsp|amp|quot|lt|gt);/g;
  let returnString = encodedString.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, '');
  returnString = returnString.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, '');
  return returnString.replace(translateRegExp, (match, entity) => translate[entity]).replace(/&#(\d+);/gi, (match, numStr) => {
    const num = parseInt(numStr, 10);
    return String.fromCharCode(num);
  });
};
export const replaceAll = (target, search, replace) => target.replace(new RegExp(search, 'g'), replace);
export const pluralise = function (s) {
  let count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  let plural = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 's';
  return count > 1 ? s + plural : s;
};
export const normalisePostCode = postCode => {
  if (typeof postCode === 'undefined') {
    return postCode;
  }
  return postCode.replace(/ /g, '');
};
export const formatVolume = volume => {
  if (volume) {
    return volume.toString().replace('.0', '');
  }
  return volume;
};
export const formatAbv = abv => {
  if (abv) {
    // .toString will remove any trailing zeros, it'll turn:
    // 10.00 => 10
    // 10.10 => 10.1
    return abv.toString();
  }
  return abv;
};

// Copied from: https://prcode.co.uk/2015/10/17/ms-word-special-characters-regex/
export const replaceMSWordNonStandardCharacters = content => {
  let cleanStr = content;

  // smart single quotes and apostrophe
  cleanStr = cleanStr.replace(/[\u2018\u2019\u201A]/g, "'");

  // smart double quotes
  cleanStr = cleanStr.replace(/[\u201C\u201D\u201E]/g, '"');

  // ellipsis
  cleanStr = cleanStr.replace(/\u2026/g, "…");

  // dashes
  cleanStr = cleanStr.replace(/[\u2013\u2014]/g, "-");

  // circumflex
  cleanStr = cleanStr.replace(/\u02C6/g, "^");

  // open angle bracket
  cleanStr = cleanStr.replace(/\u2039/g, "<");

  // close angle bracket
  cleanStr = cleanStr.replace(/\u203A/g, ">");

  // spaces
  cleanStr = cleanStr.replace(/[\u02DC\u00A0]/g, " ");
  return cleanStr;
};
export const copyElementTextToClipboard = targetElementId => {
  const copyText = document.getElementById(targetElementId)?.textContent;
  if (copyText && copyText.length > 0) {
    navigator.clipboard.writeText(copyText);
  } else console.error(`Error: No text to copy. Please make sure the target id is correct and it's text content isn't an empty string`);
};